/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Providers/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import Set from './Set/index'
import Unset from './Unset/index'



/** @type {import('Simple/types.js').View} */
export default function Providers({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences/Content/Providers"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let schedulingPreferencesProvidersValueData = fromData.useDataFormat({ viewPath,
context: 'scheduling_preferences',
path: 'providers',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: schedulingPreferencesProvidersValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Set'}>
<Set
  viewPath={`${viewPath}/Set`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unset'}>
<Unset
  viewPath={`${viewPath}/Unset`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}